module.exports = __webpack_public_path__ + "assets/media/facebook.8762af3f.svg";